var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15866_148193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0982 6.52762L12.3316 5.11026C12.3928 4.73609 12.3522 4.35234 12.2141 3.99924C12.076 3.64613 11.8455 3.33667 11.5467 3.10327C11.2479 2.86987 10.8918 2.72113 10.5158 2.67264C10.1397 2.62414 9.75759 2.67767 9.40936 2.82762C8.92808 3.0436 8.54145 3.42678 8.32116 3.9061L7.02602 6.52762H3.75033C3.19779 6.52762 2.66789 6.74712 2.27719 7.13782C1.88649 7.52852 1.66699 8.05842 1.66699 8.61096L1.66699 14.861C1.66699 15.4135 1.88649 15.9434 2.27719 16.3341C2.66789 16.7248 3.19779 16.9443 3.75033 16.9443H16.9573L18.3337 9.27971L18.3448 6.52762H12.0982ZM3.05588 14.861V8.61096C3.05588 8.42678 3.12905 8.25015 3.25928 8.11991C3.38951 7.98968 3.56615 7.91651 3.75033 7.91651H6.5281V15.5554H3.75033C3.56615 15.5554 3.38951 15.4822 3.25928 15.352C3.12905 15.2218 3.05588 15.0451 3.05588 14.861ZM16.9448 9.09707L15.7851 15.5554H7.91699V7.85332L9.59685 4.45054C9.65374 4.34762 9.73423 4.25966 9.83173 4.19391C9.92922 4.12816 10.0409 4.08648 10.1577 4.07232C10.2744 4.05815 10.3928 4.07189 10.5032 4.11241C10.6136 4.15293 10.7128 4.21907 10.7927 4.3054C10.8609 4.38474 10.9108 4.47816 10.9388 4.57899C10.9667 4.67982 10.9721 4.78559 10.9545 4.88874L10.4552 7.91651H16.9448V9.09707Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15866_148193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(1.66699 1.66699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.fdd31af85ae2b7125305406f160537db.svg";
export { ForwardRef as ReactComponent };